import { Flex } from 'yoso';
import { BaseLayout, BaseLayoutProps } from '~/components/Layout/BaseLayout';
import { FooterRouteSwitch } from '~/components/Layout/Footer/FooterRouteSwitch';
import { HeaderRouteSwitch } from '~/components/Layout/Header/HeaderRouteSwitch';
import './Layout.scss';

export type LayoutProps = BaseLayoutProps;
export const Layout = ({ children }: LayoutProps) => (
  <BaseLayout className="layout">
    <div className="base-layout-header" data-event-category="gnb">
      <HeaderRouteSwitch />
    </div>
    <Flex flex={1} className="layout-body">
      {children}
    </Flex>
    <div className="layout-footer">
      <FooterRouteSwitch />
    </div>
  </BaseLayout>
);
